import api from "./api";

export interface ConditionPhotoInterface {
  hasPhoto: boolean;
  url?: string | null;
  original_name?: string | null;
  mime_type?: string | null;
  size_bytes?: number | null;
  uploaded_at?: string | null;
}

export async function getConditionPhoto(
  workOrderId: string | number,
  workOrderDeviceId: number
): Promise<ConditionPhotoInterface> {
  const { data } = await api.get(
    `/work-order/${workOrderId}/devices/${workOrderDeviceId}/photo`
  );
  return data;
}

export async function uploadConditionPhoto(
  workOrderId: string | number,
  workOrderDeviceId: number,
  file: File
): Promise<ConditionPhotoInterface> {
  const formData = new FormData();
  formData.append("photo", file);
  const { data } = await api.post(
    `/work-order/${workOrderId}/devices/${workOrderDeviceId}/photo`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return data;
}

export async function deleteConditionPhoto(
  workOrderId: string | number,
  workOrderDeviceId: number
): Promise<void> {
  await api.delete(
    `/work-order/${workOrderId}/devices/${workOrderDeviceId}/photo`
  );
}
